// Lib
import React from 'react';

// Components
import ToolbarPopup from '../../toolbarPopup/ToolbarPopup';
import TableCellAlignmentOptions, { TableCellAlignmentOptionsProps } from './TableCellAlignmentOptions';

// Constants
import { PopupIds } from '../../../../../components/popupPanel/popupConstants';

import './TableCellAlignmentToolbarPopup.scss';

/**
 * NOTE: Structuring this as a separate component to avoid rendering the popup contents
 * when the popup isn't open.
 */
type TableCellAlignmentToolbarPopupProps = TableCellAlignmentOptionsProps & {
    buttonSelector: string;
    closePopup: () => void;
};

const TableCellAlignmentToolbarPopup: React.FC<TableCellAlignmentToolbarPopupProps> = ({
    commonTextAlignment,
    commonVerticalAlignment,
    buttonSelector,
    closePopup,
}) => (
    <ToolbarPopup
        closePopup={closePopup}
        buttonSelector={buttonSelector}
        showArrow
        popupId={PopupIds.TABLE_CELL_ALIGNMENT_TOOL}
        className="TableCellAlignmentToolbarPopup"
    >
        <TableCellAlignmentOptions
            commonTextAlignment={commonTextAlignment}
            commonVerticalAlignment={commonVerticalAlignment}
        />
    </ToolbarPopup>
);

export default TableCellAlignmentToolbarPopup;
